/* Offer boxes (sections/oricle-offer-boxes.liquid, 10/7). One press adds the model with the code already on the cart,
   and the reader stays on the page:
   1. the code goes on the cart through the Cart API (POST /cart/update.js { discount }), keeping any code already
      there. Shopify keeps a code on an empty cart and applies it once a line qualifies (checked on the store, 10/7);
   2. the variant goes in through the cart drawer (<cart-drawer>, assets/oricle-cart.js), which re-renders with the
      code on the line and opens;
   3. with no drawer on the page, the link's own href runs: /discount/CODE then /cart/add, landing on the cart.
   One press at a time; a failure leaves a plain sentence under the button and the button usable. */
(() => {
  if (customElements.get('oricle-offer-boxes')) return;
  const json = (url, body) => fetch(url, {
    method: body ? 'POST' : 'GET',
    headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'same-origin'
  }).then((r) => { if (!r.ok) throw new Error(String(r.status)); return r.json(); });

  class OricleOfferBoxes extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-o-offer-add]');
        if (!btn || !this.contains(btn)) return;
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.add !== 'function') return; // the link's own href does it
        e.preventDefault();
        this.add(btn, drawer);
      });
    }

    async applyCode() {
      const code = (this.dataset.code || '').trim();
      if (!code) return;
      const cart = await json(`${window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart'}.js`);
      const have = (cart.discount_codes || []).map((d) => d.code);
      if (have.some((c) => c.toLowerCase() === code.toLowerCase())) return;
      await json(window.routes && window.routes.cart_update_url ? `${window.routes.cart_update_url}.js` : '/cart/update.js', { discount: [...have, code].join(',') });
    }

    async add(btn, drawer) {
      if (this._busy) return;
      this._busy = true;
      const box = btn.closest('.o-obox');
      const err = box && box.querySelector('[data-o-offer-error]');
      if (err) { err.hidden = true; err.textContent = ''; }
      btn.setAttribute('aria-busy', 'true');
      try {
        try { await this.applyCode(); } catch (codeError) { /* the line still goes in; the drawer shows the real price */ }
        if (drawer.setActiveElement) drawer.setActiveElement(btn);
        await drawer.add([{ id: Number(btn.dataset.variantId), quantity: 1 }], true);
      } catch (error) {
        if (err) { err.textContent = (error && error.message && !/^\d+$/.test(error.message)) ? error.message : 'That didn’t go through. Please try again.'; err.hidden = false; }
      } finally {
        btn.removeAttribute('aria-busy');
        this._busy = false;
      }
    }
  }
  customElements.define('oricle-offer-boxes', OricleOfferBoxes);
})();
